
import { mapGetters } from 'vuex';
import { objectToSortedArray } from '../../utils';
import Message from './Message';

export default {
  name: 'ButtonGroup',
  components: {
    Message,
  },
  props: {
    subNodes: {
      type: Object,
      default: () => {},
    },
    stackIndex: {
      type: Number,
      default: null,
    },
    selectedButtonId: {
      type: String,
      default: '',
    },
    conversation: {
      type: String,
      default: '',
    },
    node: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  computed: {
    ...mapGetters('chatbotStore', ['currentConversationId', 'currentStack']),
    buttons() {
      return objectToSortedArray(this.subNodes).reduce(
        (buttons, button) => [
          ...buttons,
          ...(button.buttonTexts.map((b, i) => ({
            id: button.id,
            key: `${button.id}-${i}`,
            value: b,
          })) || []),
        ],
        []
      );
    },

    conversationWatcher() {
      return `${this.conversation}_${this.currentConversationId}`;
    },

    selectedButton() {
      return this.selectedButtonId && this.buttons.find((button) => button.key === this.selectedButtonId);
    },
  },

  watch: {
    conversationWatcher: {
      handler(value) {
        const [convId, currentConvId] = value.split('_');
        if (!convId) this.disabled = false;
        else this.disabled = convId !== currentConvId || this.currentStack.length - 1 !== this.stackIndex;
      },
      immediate: true,
    },
  },

  methods: {
    onButtonClick(value) {
      this.$store.dispatch('buttonStore/setValue', { value, stackIndex: this.stackIndex });
    },
  },
};
